<template>
  <div id="app">
    <!-- 部分路由不应该包含这个Header -->
    <!--      <Header v-if="exclude.indexOf($route.name) == -1"></Header>-->
    <Header v-if="headerShow"></Header>

    <!--<Header :class="hideClass" data-name=path></Header>-->

    <router-view />
    <!-- 部分路由不应该包含这个Footer -->
    <!--<Footer v-if="excludeFooter.indexOf($route.name) == -1"></Footer>-->
    <Footer v-if="footerShow"></Footer>
    <!-- <Footer v-show="!(path === excludeFooter)" ></Footer>-->
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import { behaviorloginOut, behaviorlogin, behaviorpageAccess } from '@/api/apiPot.js'
export default {
  name: "App",
  data() {
    return {
      headerShow: true,
      footerShow: true,
      path: "",
      beforeUnloadTime: 0,
      exclude: [
        "Login",
        "SignUp",
        "SignUp/CheckPhone",
        "SignUp/InputInfo",
        "SignUp/SignUpDone",
        "wx_login_notice",
      ],
      excludeFooter: [
        "Login",
        "SignUp",
        "SignUp/CheckPhone",
        "SignUp/InputInfo",
        "SignUp/SignUpDone",
        "forgetPassword",
        "wx_login_notice",
      ]
    };
  },
  components: {
    Header,
    Footer
  },
  computed: {
    name() {
      return this.$route.name;
    },
    hideClass() {
      return {
        comHide: this.exclude.includes(this.$route.name)
      };
    }
  },
  // 判断路由
  mounted() {
    this.path = this.$route.name;
    window.addEventListener('beforeunload', (e) => this.beforeunloadHandler(e))
    window.addEventListener('unload', (e) => this.unloadHandler(e))
    if (this.$route.path != "/Login" || "/SignUp" || '/ForgetPassword') {
      behaviorlogin({ip: localStorage.getItem('ipAddress'), inlet_index: '登入', login_device: 3}).then(() => {
      })
      behaviorpageAccess({page_index: '首页', superior_index: '登录', residence_time: 1000})
    }
  },
  methods: {
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler() {
      const gapTime = new Date().getTime() - this.beforeUnloadTime;
      if (gapTime <= 5) {
        behaviorloginOut({leave_index: '退出登录'}).then(res => {
        });
      }

    }
  },
  watch: {
    /*$route(to,from){
      this.path = to.path;
    }*/
    $route(to, from) {
      if (this.$route.path === "/Login" || "/SignUp") {
        this.headerShow = false;
        this.footerShow = false;
      } else {
        this.headerShow = true;
        this.footerShow = true;
      }

      if (
        this.$route.path === "/" ||
        this.$route.path === "/index" ||
        this.$route.path === "/GoodsList" ||
        this.$route.path === "/goodsDetail" ||
        this.$route.path === "/GoodsDetail" ||
        this.$route.path === "/GoodsDetailPreview" ||
        // this.$route.path === "/ChineseMedicineZone" ||
        this.$route.path === "/Qxzq" ||
        this.$route.path === "/ClinicZone" ||
        this.$route.path === "/BrandZone" ||
        this.$route.path === "/PublicZone" ||
        this.$route.path === "/NewDrug" ||
        this.$route.path === "/BrandList" ||
        this.$route.path === "/DailyZone" ||
        this.$route.path === "/ApparatusZone" ||
        this.$route.path === "/ApparatusZone" ||
        this.$route.path === "/ComPackageZone" ||
        this.$route.path === "/FreeZone" ||
        this.$route.path === "/SpecialZone" ||
        this.$route.path === "/EmptyPage"
      ) {
        this.headerShow = true;
        this.footerShow = true;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', (e) => this.beforeunloadHandler(e))
    window.removeEventListener('unload', (e) => this.unloadHandler(e))
    sessionStorage.setItem('new_customer', '')
  }
};
</script>
<style lang="less" scoped>
#app {
  background-color: #fff;
}

.comHide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue